var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5"},[_c('vue-headful',{attrs:{"title":"ePlato"}}),_c('div',{staticClass:"title"},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" "+_vm._s(_vm.$t("finalExam.chooseMenuItemOnLeft")))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }